import { convertToCommonErrors } from '../../common/utils/errorUtils.js';
import { TypeKeys, generateActionId } from './actionsUtils.js';
import type { DisplayItemsLoadAction, ErrorAction, ErrorActionCreator } from './actionsUtils.js';
import type { GenericError, VirtualCatalog, VirtualCatalogResponse } from '../../generated/api/models.js';

export interface SetSelectedVirtualCatalogAction {
  type: TypeKeys.SET_SELECTED_VIRTUAL_CATALOG;
  selectedCatalogCode: string | null;
}

export const setSelectedVirtualCatalog = (selectedCatalogCode: string | null): SetSelectedVirtualCatalogAction => ({
  selectedCatalogCode,
  type: TypeKeys.SET_SELECTED_VIRTUAL_CATALOG,
});

// LOAD VIRTUAL CATALOGS

export interface LoadVirtualCatalogsAction
  extends DisplayItemsLoadAction<TypeKeys.LOAD_VIRTUAL_CATALOGS, VirtualCatalog> {
  forceLoad?: boolean;
  catalogPreSelected: boolean;
}

export const loadVirtualCatalogs = (forceLoad?: boolean, catalogPreSelected?: boolean): LoadVirtualCatalogsAction => {
  return {
    forceLoad,
    id: generateActionId(),
    type: TypeKeys.LOAD_VIRTUAL_CATALOGS,
    catalogPreSelected: catalogPreSelected ?? false,
  };
};

export interface LoadVirtualCatalogsFulfilledAction {
  type: TypeKeys.LOAD_VIRTUAL_CATALOGS_FULFILLED;
  catalogs?: VirtualCatalog[];
  total: number;
  catalogPreSelected: boolean;
}

export const loadVirtualCatalogsFulfilled = (
  response: VirtualCatalogResponse,
  catalogPreSelected: boolean
): LoadVirtualCatalogsFulfilledAction => {
  return {
    catalogs: response.items,
    total: response.total,
    type: TypeKeys.LOAD_VIRTUAL_CATALOGS_FULFILLED,
    catalogPreSelected,
  };
};
export type LoadVirtualCatalogsFailedAction = ErrorAction<TypeKeys.LOAD_VIRTUAL_CATALOGS_FAILED>;

export const loadVirtualCatalogsFailed: ErrorActionCreator<TypeKeys.LOAD_VIRTUAL_CATALOGS_FAILED> = (
  message: string,
  status: number,
  errors?: GenericError[]
): LoadVirtualCatalogsFailedAction => {
  const commonErrors = convertToCommonErrors(message, status, errors);
  return {
    errors: commonErrors,
    type: TypeKeys.LOAD_VIRTUAL_CATALOGS_FAILED,
  };
};

export type CatalogsActionTypes =
  | SetSelectedVirtualCatalogAction
  | LoadVirtualCatalogsAction
  | LoadVirtualCatalogsFulfilledAction
  | LoadVirtualCatalogsFailedAction;
